import {createIcon} from '@chakra-ui/icons';

export const TeamLocationIcon = createIcon({
  displayName: 'AdministrationIcon',
  viewBox: '0 0 25 25',
  path: (
    <>
      <path
        d='M0.5 1.5V19L6.2646 21.5H24.5V5.5L16.5 1.5L8.5 5.5L0.5 1.5Z'
        fill='#5EB5AB'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.63075 1.00003C0.548191 0.999269 0.4663 1.01487 0.389807 1.04594C0.313313 1.07701 0.243734 1.12293 0.185087 1.18104C0.126439 1.23915 0.0798874 1.30831 0.0481193 1.38452C0.0163512 1.46072 -3.49355e-06 1.54247 5.59759e-10 1.62503V19.1975C1.99877e-05 19.3166 0.0340811 19.4333 0.0981714 19.5337C0.162262 19.6341 0.253712 19.7141 0.36175 19.7643L5.5 22.0586C5.5075 21.6139 5.5365 21.1679 5.604 20.7286L1.25 18.7985V2.60453L8.06875 5.77203V13.5C8 13.5 8.54385 12.8709 8.81525 12.7031L8.81925 5.86278L15.9882 2.53253L15.9797 8.58567C16.1641 8.58567 17 9 17 9L16.7377 2.44403L23.75 5.70128V12.9093C23.7507 12.9645 23.7512 13.02 23.75 13.0753L23.5 18.0586C23.8665 18.3361 24.1975 18.6586 24.4722 19.0299C24.5723 19.1639 24.9137 19.9171 25 20.0586V5.30253C25 5.18341 24.9659 5.06677 24.9018 4.96636C24.8377 4.86596 24.7463 4.78595 24.6383 4.73578L16.7218 1.05828C16.6374 1.01904 16.5453 0.999141 16.4522 1.00003C16.3633 1.00081 16.2755 1.02058 16.1947 1.05803L8.5415 4.61328L0.88825 1.05828C0.807544 1.02075 0.719752 1.00089 0.63075 1.00003ZM8.13025 16.5538L8.13125 16.6688C8.15775 16.6588 8.18325 16.6455 8.21 16.6358C8.18225 16.6095 8.1575 16.5808 8.13025 16.5538Z'
        fill='white'
      />
      <path
        d='M18.0106 11.5416C18.0106 12.9384 16.8756 14.076 15.4821 14.076C14.0885 14.076 12.9536 12.9384 12.9536 11.5416C12.9536 10.1448 14.0885 9.0072 15.4821 9.0072C16.8828 9.0072 18.0106 10.1448 18.0106 11.5416Z'
        fill='#F7F7F9'
      />
      <path
        d='M15.4892 9C14.0956 9 12.9607 10.1376 12.9607 11.5344H18.0106C18.0106 10.1376 16.8828 9 15.4892 9Z'
        fill='#F6704D'
      />
      <path
        d='M15.4892 14.076C13 13.5 12.5 18.5 14 18.5H17C18.5 17 17.9172 14.076 15.4892 14.076Z'
        fill='#F6704D'
      />
      <path d='M17 18.5H14L15 20H16L17 18.5Z' fill='white' />
      <path
        d='M13.0684 15.192C13.0684 16.6176 11.9119 17.7768 10.4896 17.7768C9.06729 17.7768 7.9108 16.6176 7.9108 15.192C7.9108 13.7664 9.06729 12.6072 10.4896 12.6072C11.9119 12.6072 13.0684 13.7664 13.0684 15.192Z'
        fill='white'
      />
      <path
        d='M10.4896 12.6C9.06729 12.6 7.9108 13.7592 7.9108 15.1848H13.0756C13.0685 13.7592 11.9119 12.6 10.4896 12.6Z'
        fill='#FFB800'
      />
      <path
        d='M10.4896 17.784C8.01134 17.784 6 19.8 6 22.284H14.9792C14.9792 19.8 12.9679 17.784 10.4896 17.784Z'
        fill='#FFB800'
      />
      <path
        d='M23.082 15.192C23.082 16.6176 21.9255 17.7768 20.5032 17.7768C19.0809 17.7768 17.9244 16.6176 17.9244 15.192C17.9244 13.7664 19.0809 12.6072 20.5032 12.6072C21.9255 12.6072 23.082 13.7664 23.082 15.192Z'
        fill='#F7F7F9'
      />
      <path
        d='M20.5032 12.6C19.0809 12.6 17.9244 13.7592 17.9244 15.1848H23.082C23.082 13.7592 21.9255 12.6 20.5032 12.6Z'
        fill='#3885FE'
      />
      <path
        d='M20.5032 17.784C18.025 17.784 16.0136 19.8 16.0136 22.284H24.9928C24.9928 19.8 22.9815 17.784 20.5032 17.784Z'
        fill='#3885FE'
      />
    </>
  ),
});
